import * as React from 'react'
import { UserInviteCardConnected } from './UserInviteCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_INVITE_A_ID } from 'mockState'

export const UserInviteCardExamples = () => {
  return (
    <div className="UserInviteCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UserInviteCardConnected inviteId={MOCK_INVITE_A_ID} />
      </Provider>
    </div>
  )
}
